// extracted by mini-css-extract-plugin
export default {"file_upload_wrapper":"styles_file_upload_wrapper__-O10b"};